import React, {useEffect, useState} from "react";
import {VerifyBankBodyWrapper} from "../components/deposit/styled.jsx";
import confirmSuccess from "../assets/confirmSuccess.svg";
import errorIcon from "../assets/error-icon.svg";
import {Footer} from "react-components-core";
import {isMobileDevice} from "../utils/common";
import styled from "@emotion/styled";
import {customDesktop, customMobile} from "../globalStyleds";
import {parseURL} from "../utils/convertParams";
import LoadingProgress from "../components/loading/index.jsx";
import {STATUS_PROGRESS_LOADING} from "../constants/status";
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';



const VerifyCompleteWrapperContent = styled.div`
  width: 100%;
  text-align: center;
  height: calc(100%);
  position: relative;
  align-items: flex-end;
  background: ${props => props.theme.palette.background.default};
  &.full-height {
    height: auto;
  }

  .content {
    min-height: calc(100%);
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    h1 {
      margin-left: 18px;
      margin-right: 18px;
      margin-bottom: 18px;
      font-size: 25px;
      line-height: 28px;
      color: ${props => props.theme.palette.text.primary};
    }

    p {
      margin-bottom: 16px;
      line-height: 24px;
      font-size: 22px;
      color: ${props => props.theme.palette.text.secondary};
    }

    img {
      padding: 0;
      margin-bottom: 15px;
      justify-content: space-between;
      align-items: center;
      position: relative;
    }
  }

  .hidden {
    display: none;
  }

`;

const VerifyCompleteStyled = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => (props.customStyle.isMobile ? customMobile : customDesktop(props))}
`;

export const SafeToClosePage = () => {
    const appStore = useSelector((state) => state).app;
    const { t } = useTranslation();

    const messageTransCompleted = appStore?.obvInfo?.properties?.genericMessageTransCompleted || t('common.transaction.result.safeToClose.description');

    const [isMobile] = useState(isMobileDevice());
    const {params} = parseURL(window.location.href);
    const { redirectUrl, isSuccess, isCancel } = params;
    const isTxnSuccess = isSuccess === 'true';
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [statusProgress, setStatusProgress] = useState(STATUS_PROGRESS_LOADING.START);

    useEffect(() => {
        if (redirectUrl?.trim() && isImageLoaded && isLoading) {
            setTimeout(() => {
                window.location.href = redirectUrl;
            }, 1000);
        }
    }, [redirectUrl, isImageLoaded, isLoading]);

    useEffect(() => {
        if (isLoading) {
            setStatusProgress(STATUS_PROGRESS_LOADING.START);
        } else {
            setStatusProgress(STATUS_PROGRESS_LOADING.FINISH);
        }
        return () => {
            setStatusProgress(STATUS_PROGRESS_LOADING.NONE);
        };
    }, [isLoading]);

    return (
        <div className='VerifyBank'>
            <VerifyBankBodyWrapper>
                <VerifyCompleteStyled customStyle={{isMobile: isMobile}}>
                    <div className='box-extend'>
                        <VerifyCompleteWrapperContent>
                            <div className={`content ${isLoading ? "" : "hidden"}`}>
                                <img src={isTxnSuccess ? confirmSuccess : errorIcon}
                                     alt='confirmIcon'
                                     onLoad={() => setIsImageLoaded(true)}
                                />
                                <h1>{isTxnSuccess ? t("common.transaction.completed") : t("common.transaction.cancelled")}</h1>
                                <p><strong>{isTxnSuccess ? messageTransCompleted : (isCancel ? t("error.generic.subtitle") : "")}</strong></p>
                            </div>
                        </VerifyCompleteWrapperContent>
                        <LoadingProgress
                            active={!isLoading}
                            messages={[t("loading.message.processing")]}
                            timeBackgroundRun={1000}
                            progress={statusProgress}
                            afterFinish={() => {
                                setIsLoading(true);
                                setStatusProgress(STATUS_PROGRESS_LOADING.NONE);
                            }}
                        />
                    </div>
                </VerifyCompleteStyled>
            </VerifyBankBodyWrapper>
            <Footer integration='plaidNuvei'></Footer>
        </div>
    );
};

export default SafeToClosePage;